import { render, staticRenderFns } from "./payouts.vue?vue&type=template&id=6979284a&scoped=true"
import script from "./payouts.vue?vue&type=script&lang=js"
export * from "./payouts.vue?vue&type=script&lang=js"
import style0 from "./payouts.vue?vue&type=style&index=0&id=6979284a&prod&scoped=true&lang=less"
import style1 from "./payouts.vue?vue&type=style&index=1&id=6979284a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979284a",
  null
  
)

export default component.exports